import React, { useEffect, useRef, useState } from 'react';
import './ColumnFilter.css';
import { FiFilter } from 'react-icons/fi';

interface Props {
  columnKey: string;
  data: any[];
  selected: string[];
  updateFilter: (col: string, values: string[]) => void;
  applyFilter: () => void;
  clearFilter: (col: string) => void;
}

const ColumnFilter: React.FC<Props> = ({
  columnKey,
  data,
  selected,
  updateFilter,
  applyFilter,
  clearFilter,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef<HTMLDivElement>(null);

  const values = Array.from(new Set(data.map((item) => item[columnKey]))).filter(Boolean);
  const filteredValues = values.filter((v) => v.includes(search));

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleValue = (value: string) => {
    if (selected.includes(value)) {
      updateFilter(
        columnKey,
        selected.filter((v) => v !== value),
      );
    } else {
      updateFilter(columnKey, [...selected, value]);
    }
  };

  return (
    <div className='filter-container' ref={ref}>
      <FiFilter className='filter-icon' onClick={() => setOpen((prev) => !prev)} />
      {open && (
        <div className='filter-dropdown'>
          <input
            className='filter-search'
            type='text'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder='חיפוש...'
          />
          <div className='filter-options'>
            {filteredValues.map((value) => (
              <label key={value} className='filter-option'>
                <input
                  type='checkbox'
                  checked={selected.includes(value)}
                  onChange={() => toggleValue(value)}
                />
                {value}
              </label>
            ))}
          </div>
          <div className='filter-buttons'>
            <button onClick={() => clearFilter(columnKey)}>נקה</button>
            <button
              onClick={() => {
                applyFilter();
                setOpen(false);
              }}
            >
              סנן
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColumnFilter;
